// extracted by mini-css-extract-plugin
export default {"option_wrapper":"Option_option_wrapper__ABLAW","option":"Option_option__neRlA","selector_user":"Option_selector_user__i6Udi","name":"Option_name__BxAjl"};